import React from 'react'
import {useTranslations} from 'next-intl'
import {css} from '@emotion/react'

import {useAppCtx} from '../../../../contexts/appCtx'
import Button from '../../../../components/elements/Button'
import BasicDialog from '../../../../components/elements/BasicDialog'

export default function ClearOptionsDialog({
                                             open,
                                             onClose,
                                             defaultOptions,
                                             onOptionsChange,
                                           }) {

  const styles = {
    description: css`
      padding: 16px;
      font-size: 1.2rem;
    `,
    actions: css`
      display: flex;
      justify-content: space-between;
      gap: 8px;
    `,
  }

  const appCtx = useAppCtx()
  const t = useTranslations()

  const clearOptions = () => {
    onOptionsChange(() => [])
    onClose()
  }

  const resetOptions = () => {
    onOptionsChange(() => defaultOptions)
    onClose()
  }

  return (
    <BasicDialog
      title={t('draw-lots.clear-options-dialog.title')}
      open={open}
      onClose={onClose}
      actions={(
        <div css={styles.actions}>
          {appCtx.isMobile ? (
            <div/>
          ) : (
            <Button onClick={resetOptions}>{t('draw-lots.clear-options-dialog.reset')}</Button>
          )}

          <div css={css`
            display: flex;
            gap: 8px;
          `}>
            <Button secondary onClick={onClose}>{t('draw-lots.clear-options-dialog.cancel')}</Button>
            <Button onClick={clearOptions}>{t('draw-lots.clear-options-dialog.clear')}</Button>
          </div>
        </div>
      )}
    >
      <div css={styles.description}>
        <div>{t('draw-lots.clear-options-dialog.description')}</div>
      </div>
    </BasicDialog>
  )
}
